export default "__VITE_ASSET__89531c6e__"